// include directives/components commonly used in features modules in this shared modules
// and import me into the feature module
// importing them individually results in: Type xxx is part of the declarations of 2 modules: ... Please consider moving to a higher module...
// https://github.com/angular/angular/issues/10646  

import { ApplicationRef, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { PhoneMaskDirective } from '../../directives/phone-mask.directive';
import { EinMaskDirective } from '../../directives/ein-mask.directive';

import { myFocus } from '../../directives/focus.directive';

import { AddDocumentDialog, ProjectDocumentsComponent } from '../controls/project-documents/project.documents.component';
import { AddNoteDialog, ProjectNotesComponent } from '../controls/project-notes/project.notes.component';
import { ProjectInfoShellComponent } from '../controls/project-info/project.info.shell.component';
import { SpinnerComponent } from '../controls/spinner/spinner.component';
import { ConvertStatusPipe } from '../pipes/convertStatusPipe';
import { ConvertProbabilityPipe } from '../pipes/convertProbabilityPipe';
import { HeaderComponent } from '../controls/header/header.component';
import { UserEditComponent } from '../../user/edit/edit.component';

import { QuoteDetailsComponent } from '../controls/quote/quote-details/quote-details.component';
import { QuoteStatusDialog, QuoteEmailDialog, QuoteCopyDialog } from '../controls/quote/quote-details/quote-details.component';
import { QuoteAreaDialog } from '../controls/quote/quote-area/quote-area.dialog';
import { DealerAccountComponent } from '../controls/dealer-account/dealer-account.component';
import { FooterComponent } from '../../footer/footer.component';
import { DealerLogoComponent } from '../controls/dealer-logo/dealer.logo.component';
import { PageHeaderComponent } from '../mobile-controls/page-header/page-header.component';
import { HomeMobileComponent } from '../../home/mobile/home-mobile.component';
import { HomeDesktopComponent } from '../../home/desktop/home-desktop.component';
import { QuoteInfoComponent } from '../mobile-controls/quote-info/quote-info.component';
import { ProjectInfoDesktopComponent } from '../controls/project-info/project-info-desktop/project-info-desktop.component';
import { ProjectInfoMobileComponent } from '../controls/project-info/project-info-mobile/project-info-mobile.component';
import { ProjectNotesMobileComponent } from '../controls/project-notes/project-notes-mobile/project-notes-mobile.component';
import { ProjectDocumentsMobileComponent } from '../controls/project-documents/project-documents-mobile/project-documents-mobile.component';
import { QuoteDetailsMobileComponent } from '../controls/quote/quote-details/quote-details-mobile/quote-details-mobile.component';
import { CustomerInfoSummaryMobileComponent } from '../mobile-controls/customer-info-summary-mobile/customer-info-summary-mobile.component';
import { ItemCostValidator } from '../../quote/customValidators/item-cost-validator.directive';
import { QuoteTemplateDialog } from '../controls/quote/create-quote-template/create-quote-template.dialog';
import { PrintOptionsDialog } from '../controls/print-options-dialog/print.options.dialog';
import { PrintLanguageDialog } from '../controls/print-language-dialog/print.language.dialog';
import { WorkOrderDialog } from '../controls/work-order-dialog/work.order.dialog';
import { FileUploadComponent } from '../controls/file-upload/file.upload.component';
import { MessageDialog } from '../controls/message-dialog/message.dialog';
import { ServiceLocator, services } from '../services/service.locator';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { DealerDocumentSelectionComponent } from '../controls/dealer-document-selection/dealer-document-selection.component';
import { QuoteTaxOptionsDialog } from '../controls/quote/quote-tax-options/quote-tax-options.dialog';
import { AcknowledgementListComponent } from '../controls/acknowledgement-list/acknowledgement-list.component';
import { AcknowledgementListMobileComponent } from '../controls/acknowledgement-list/acknowledgement-list-mobile/acknowledgement-list-mobile.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialsListDialogComponent } from '../controls/materials-list-dialog/materials-list-dialog.component';
import { SignaturePadComponent } from '../controls/signature-pad/signature-pad.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule,
    MatAutocompleteModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatPaginatorModule,
    MatRadioModule, MatSelectModule, MatSortModule, MatTableModule, MatTabsModule,
    MatToolbarModule, MatTooltipModule, MatExpansionModule,
    InfiniteScrollModule, DragDropModule],
    
  declarations: [myFocus,
    AcknowledgementListComponent, AcknowledgementListMobileComponent,
    ProjectDocumentsComponent, ProjectDocumentsMobileComponent, AddDocumentDialog,
    ProjectNotesComponent, ProjectNotesMobileComponent, AddNoteDialog,
    ProjectInfoShellComponent, ProjectInfoDesktopComponent, ProjectInfoMobileComponent,
    SpinnerComponent, HeaderComponent, FooterComponent,
    PhoneMaskDirective, EinMaskDirective, ConvertStatusPipe, ConvertProbabilityPipe, UserEditComponent, DealerAccountComponent,
    DealerLogoComponent,
    DealerDocumentSelectionComponent,
    FileUploadComponent,
    MessageDialog,
    QuoteDetailsComponent, QuoteDetailsMobileComponent,
    QuoteStatusDialog, QuoteEmailDialog, QuoteCopyDialog, QuoteAreaDialog, QuoteTaxOptionsDialog,
    QuoteTemplateDialog,
    PrintLanguageDialog,
    PrintOptionsDialog,
    MaterialsListDialogComponent,
    WorkOrderDialog,
    PageHeaderComponent, HomeMobileComponent, HomeDesktopComponent,
    QuoteInfoComponent,
    CustomerInfoSummaryMobileComponent,
    ItemCostValidator,
    SignaturePadComponent,
  ],
  exports: [myFocus,
    AcknowledgementListComponent, AcknowledgementListMobileComponent,
    ProjectDocumentsComponent, ProjectDocumentsMobileComponent,
    ProjectNotesComponent, ProjectNotesMobileComponent,
    ProjectInfoShellComponent, ProjectInfoDesktopComponent, ProjectInfoMobileComponent,
    SpinnerComponent, HeaderComponent, FooterComponent,
    MatAutocompleteModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatPaginatorModule,
    MatRadioModule, MatSelectModule, MatSortModule, MatTableModule, MatTabsModule,
    MatToolbarModule, MatTooltipModule, MatExpansionModule,
    InfiniteScrollModule,
    PhoneMaskDirective, EinMaskDirective, ConvertStatusPipe, ConvertProbabilityPipe, UserEditComponent, DealerAccountComponent,
    DealerLogoComponent,
    DealerDocumentSelectionComponent,
    FileUploadComponent,
    MessageDialog,
    QuoteDetailsComponent, QuoteDetailsMobileComponent,
    QuoteStatusDialog, QuoteEmailDialog, QuoteCopyDialog, QuoteAreaDialog, QuoteTaxOptionsDialog,
    QuoteTemplateDialog,
    PrintLanguageDialog,
    PrintOptionsDialog,
    MaterialsListDialogComponent,
    WorkOrderDialog,
    QuoteInfoComponent,
    CustomerInfoSummaryMobileComponent,
    PageHeaderComponent, HomeMobileComponent, HomeDesktopComponent,
    ItemCostValidator,
    SignaturePadComponent],
  providers: []
})
export class SharedModule {
  constructor(public dialog: MatDialog,
    router: Router,
    media: MediaMatcher,
    changeDetectorRef: ApplicationRef) {

    ServiceLocator.injector = Injector.create({
      providers:
        Object.keys(services).map(key => ({
          provide: services[key].provide,
          useClass: services[key].provide,
          deps: services[key].deps
        }))
    });
    ServiceLocator.dialog = dialog;
    ServiceLocator.media = media;
    ServiceLocator.router = router;
    ServiceLocator.changeDetectorRef = changeDetectorRef;
  }
}
